import { render, staticRenderFns } from "./RoomPage.vue?vue&type=template&id=3ce0ed4e&lang=pug&"
import script from "./RoomPage.vue?vue&type=script&lang=js&"
export * from "./RoomPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RoomPage.vue"
export default component.exports